var map = {
	"./Assign.svg": "./src/assets/icons/Assign.svg",
	"./Assign_with_Template.svg": "./src/assets/icons/Assign_with_Template.svg",
	"./Blinking_by_Label.svg": "./src/assets/icons/Blinking_by_Label.svg",
	"./Blinking_by_Product.svg": "./src/assets/icons/Blinking_by_Product.svg",
	"./Delete.svg": "./src/assets/icons/Delete.svg",
	"./Label_Info.svg": "./src/assets/icons/Label_Info.svg",
	"./Mapping.svg": "./src/assets/icons/Mapping.svg",
	"./Multi_Assign.svg": "./src/assets/icons/Multi_Assign.svg",
	"./Page_Flipping.svg": "./src/assets/icons/Page_Flipping.svg",
	"./PowerRailAssign.svg": "./src/assets/icons/PowerRailAssign.svg",
	"./PowerRailUnAssign.svg": "./src/assets/icons/PowerRailUnAssign.svg",
	"./Product_Info.svg": "./src/assets/icons/Product_Info.svg",
	"./SensorAssign.svg": "./src/assets/icons/SensorAssign.svg",
	"./SensorUnAssign.svg": "./src/assets/icons/SensorUnAssign.svg",
	"./Unassign.svg": "./src/assets/icons/Unassign.svg",
	"./VisionAssign.svg": "./src/assets/icons/VisionAssign.svg",
	"./Vision_ic.svg": "./src/assets/icons/Vision_ic.svg",
	"./Vision_icd.svg": "./src/assets/icons/Vision_icd.svg",
	"./ad_info.svg": "./src/assets/icons/ad_info.svg",
	"./extra_assign.svg": "./src/assets/icons/extra_assign.svg",
	"./firmware_d.svg": "./src/assets/icons/firmware_d.svg",
	"./firmware_w.svg": "./src/assets/icons/firmware_w.svg",
	"./gateway_d.svg": "./src/assets/icons/gateway_d.svg",
	"./gateway_w.svg": "./src/assets/icons/gateway_w.svg",
	"./icon_w.svg": "./src/assets/icons/icon_w.svg",
	"./label_d.svg": "./src/assets/icons/label_d.svg",
	"./label_w.svg": "./src/assets/icons/label_w.svg",
	"./multi_d.svg": "./src/assets/icons/multi_d.svg",
	"./multi_w.svg": "./src/assets/icons/multi_w.svg",
	"./overview_d.svg": "./src/assets/icons/overview_d.svg",
	"./overview_w.svg": "./src/assets/icons/overview_w.svg",
	"./product_d.svg": "./src/assets/icons/product_d.svg",
	"./product_w.svg": "./src/assets/icons/product_w.svg",
	"./pwrrail_d.svg": "./src/assets/icons/pwrrail_d.svg",
	"./pwrrail_w.svg": "./src/assets/icons/pwrrail_w.svg",
	"./sensor_d.svg": "./src/assets/icons/sensor_d.svg",
	"./sensor_w.svg": "./src/assets/icons/sensor_w.svg",
	"./store_d.svg": "./src/assets/icons/store_d.svg",
	"./store_w.svg": "./src/assets/icons/store_w.svg",
	"./sys-config_d.svg": "./src/assets/icons/sys-config_d.svg",
	"./sys-config_w.svg": "./src/assets/icons/sys-config_w.svg",
	"./template_d.svg": "./src/assets/icons/template_d.svg",
	"./template_w.svg": "./src/assets/icons/template_w.svg",
	"./user_d.svg": "./src/assets/icons/user_d.svg",
	"./user_w.svg": "./src/assets/icons/user_w.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";